/*
 * Copyright (c) 2025 Ipivot Corporation.
 * All rights reserved.
 * This software is the confidential and proprietary information of
 *  Ipivot Corporation ("Confidential Information").
 */
import { createContext } from 'react';

export interface SettingsContextType {
    isDirty: boolean;
    setIsDirty: (dirty: boolean) => void;
}

export const SettingsContext = createContext<SettingsContextType>({
    isDirty: false,
    setIsDirty: () => {},
});
